// One backend draft_status, mapped to role-facing labels/colors here so the
// wording differs without needing a second backend status.
const PM_STATUS = {
  draft: { label: 'Draft', color: 'bg-gray-400' },
  requested: { label: 'Requested', color: 'bg-amber-400' },
  submitted: { label: 'In Review', color: 'bg-pink-500' },
  revision_requested: { label: 'Revision', color: 'bg-orange-500' },
  internally_approved: { label: 'Approved', color: 'bg-rb-green' },
  client_review: { label: 'Client Review', color: 'bg-orange-500' },
  approved: { label: 'Approved', color: 'bg-rb-green' },
}

// The influencer never sees "client_review" as its own concept - it's still
// just "in review" from their side, since client feedback stays internal
// until the PM releases it.
//
// internally_approved deliberately does NOT reuse the "Approved" label/color
// that approved does, even though both look the same to the PM: it can still
// be pending a client step the influencer has no visibility into (Reachbird
// may not have sent it to the client yet, or ever intends to), so "Approved"
// must only ever mean fully done, safe to post. Reusing blue here (this
// map's existing "still pending something" color, also used for
// submitted/client_review) avoids implying a premature all-clear.
const INFLUENCER_STATUS = {
  draft: { label: 'To Do', color: 'bg-gray-400' },
  requested: { label: 'To Do', color: 'bg-gray-400' },
  submitted: { label: 'In Review', color: 'bg-blue-500' },
  revision_requested: { label: 'Revision Needed', color: 'bg-orange-500' },
  internally_approved: { label: 'Approved by Reachbird', color: 'bg-blue-500' },
  client_review: { label: 'In Review', color: 'bg-blue-500' },
  approved: { label: 'Approved', color: 'bg-rb-green' },
}

// The client only sees client_review, approved, or revision_requested (their
// own feedback round) - other statuses are never visible to them, but the
// map covers everything so an unexpected status still renders sanely.
const CLIENT_STATUS = {
  draft: { label: 'Not Ready', color: 'bg-gray-400' },
  requested: { label: 'Not Ready', color: 'bg-gray-400' },
  submitted: { label: 'Not Ready', color: 'bg-gray-400' },
  revision_requested: { label: 'In Progress', color: 'bg-orange-500' },
  internally_approved: { label: 'Not Ready', color: 'bg-gray-400' },
  client_review: { label: 'Awaiting Your Review', color: 'bg-orange-500' },
  approved: { label: 'Approved', color: 'bg-rb-green' },
}

export function pmDraftStatus(draftStatus) {
  return PM_STATUS[draftStatus] || PM_STATUS.draft
}

export function influencerDraftStatus(draftStatus) {
  return INFLUENCER_STATUS[draftStatus] || INFLUENCER_STATUS.draft
}

export function clientDraftStatus(draftStatus) {
  return CLIENT_STATUS[draftStatus] || CLIENT_STATUS.client_review
}

// client_review looks identical to every role whether or not the client has
// already responded this round - the map alone can't tell those apart, so
// this fills in the label/color each role needs once the client's feedback
// has actually landed (PM: it's their turn now; client: they're done).
const CLIENT_RESPONDED_OVERRIDE = {
  pm: { label: 'Client Feedback', color: 'bg-pink-500' },
  client: { label: 'Feedback Sent', color: 'bg-blue-500' },
}

export function clientFeedbackSentOverride(role, draftStatus, feedbackSubmitted) {
  if (draftStatus !== 'client_review' || !feedbackSubmitted) return null

  return CLIENT_RESPONDED_OVERRIDE[role] || null
}
